"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDisconnectOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.disconnect_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "disconnect_outline_svg__transparent_box" },
            React.createElement("path", { className: "disconnect_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "disconnect_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "disconnect_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M7.06 19.94l5.47-5.47a13.53 13.53 0 00-6.7 4.25zM25.47 9.33L30 4.81V2L2 30h2.82L11 23.85 12.1 25a4.94 4.94 0 018 0l1.44-1.44a7 7 0 00-8.34-1.96l5.36-5.35a11.47 11.47 0 016.37 3.88l1.41-1.41a13.45 13.45 0 00-6.16-4.09L24 10.82a18.07 18.07 0 015.77 4.48l1.42-1.42a20.52 20.52 0 00-5.72-4.55zM16.09 9c.62 0 1.23 0 1.84.1l1.76-1.76a19.44 19.44 0 00-3.6-.34A20 20 0 001 13.88l1.41 1.42A18 18 0 0116.09 9z" }))));
}
exports.default = SvgDisconnectOutline;
//# sourceMappingURL=DisconnectOutline.js.map